import React, { useState } from 'react';

import Modal from '../../modal/Modal';
import networkIcons from '../../assets/network-render-icons.svg';
import illustration from '../../assets/categories/illustration.png';

import samplePostImage from '../../assets/magic.svg';
import { ModalHeader } from '../../categories/Modals/ModalHeader';
import { PostCardBlock } from '../PublicationPreview';
import { ButtonLarge } from '../../components/Button';
import {
    isPublicationLibraryCreationMode,
    isPublicationOwnCreationMode,
    PublicationCreationMode,
} from '../types';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onValidate: (mode: PublicationCreationMode) => void;
};

export function PublicationCreationChoiceModal({ isOpen, onClose, onValidate }: Props) {
    const [mode, setMode] = useState<PublicationCreationMode>(PublicationCreationMode.Library);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader />
            <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
                <div className="flex flex-col">
                    <p className="text-center text-sm font-medium text-dark-gray">
                        Choisir une publication de la bibliothèque
                    </p>
                    <button
                        type="button"
                        onClick={() => setMode(PublicationCreationMode.Library)}
                        className={`flex flex-col items-center rounded-lg p-6 text-left transition-colors ${
                            isPublicationLibraryCreationMode(mode) ? 'bg-primary/40' : ''
                        }`}
                    >
                        <PostCardBlock
                            agencyName={'Compte agence'}
                            publicationTitle={'Les obligations légales du vendeur'}
                            mediaUrl={illustration}
                            extension={''}
                            isGlobal={false}
                            networkIcon={networkIcons}
                            link={'#immobilier #juridique'}
                            textBlock={
                                'Les obligations légales du vendeur (vices cachés, diagnostics, etc.)'
                            }
                        />
                    </button>
                    <div
                        onClick={() => setMode(PublicationCreationMode.Library)}
                        className="mt-1 flex w-full items-center justify-center gap-2"
                    >
                        <Radio selected={isPublicationLibraryCreationMode(mode)} />
                    </div>
                </div>

                <div className="flex flex-col">
                    <p className="text-center text-sm font-medium text-dark-gray">
                        Créer votre propre publication
                    </p>
                    <button
                        type="button"
                        onClick={() => setMode(PublicationCreationMode.Own)}
                        className={`flex flex-col items-center gap-2 rounded-[12px] p-6 text-left transition-colors ${
                            isPublicationOwnCreationMode(mode) ? 'bg-primary/40' : ''
                        }`}
                    >
                        <PostPreviewCreateOwn />
                    </button>
                    <button
                        type="button"
                        onClick={() => setMode(PublicationCreationMode.Own)}
                        className="mt-1 flex w-full items-center justify-center gap-2"
                    >
                        <Radio selected={isPublicationOwnCreationMode(mode)} />
                    </button>
                </div>
            </div>

            <div className="mt-4 flex w-full justify-center">
                <div className="w-full max-w-md">
                    <ButtonLarge
                        type="button"
                        isPrimary
                        onClick={() => onValidate(mode)}
                        style={{ width: '100%' }}
                    >
                        Valider mon choix
                    </ButtonLarge>
                </div>
            </div>
        </Modal>
    );
}

function PostPreviewCreateOwn() {
    return (
        <div className="w-full sm:max-w-[320px] md:max-w-[360px] lg:max-w-[400px] bg-white rounded-md shadow-lg overflow-hidden">
            <div className="flex w-full gap-2 h-[20px] sm:h-[24px] md:h-[28px] my-2 px-1.5 sm:px-2 md:px-2.5 text-[9px] sm:text-[10px] md:text-xs font-light items-center">
                <span className="h-5 w-5 rounded-full bg-[#E0E0E0]" />
                <div className="flex-1 space-y-1">
                    <span className="block h-1.5 w-20 bg-[#E0E0E0] rounded" />
                    <span className="block h-1.5 w-14 bg-[#E8E8E8] rounded" />
                </div>
            </div>
            <div className="flex h-[280px] w-full items-center justify-center bg-light-gray sm:h-[320px] md:h-[360px] lg:h-[400px]">
                <img src={samplePostImage} alt="" className="h-6 w-6 opacity-30" />
            </div>
            <div className={'flex flex-col gap-2'}>
                <img
                    className="w-full px-1.5 sm:px-2 md:px-2.5 py-1 sm:py-1.5 md:py-2"
                    src={networkIcons}
                    alt="icons"
                />
                <div
                    className="w-full
                                px-1.5
                                pb-1
                                mb-2
                                space-y-1.5
                                "
                >
                    <span className="block h-1.5 w-[80%] max-w-full bg-[#D8D8D8] rounded" />
                    <span className="block h-1.5 w-[60%] max-w-full bg-[#E0E0E0] rounded" />
                    <span className="block h-1.5 w-[45%] max-w-full bg-[#E8E8E8] rounded" />
                </div>
                <div className={'w-full px-1.5 mb-2'}>
                    <span className="block h-2 w-[30%] max-w-full bg-[#E8E8E8] rounded" />
                </div>
            </div>
        </div>
    );
}

function Radio({ selected }: { selected: boolean }) {
    return (
        <div
            className={`h-4 w-4 rounded-full border-2 shrink-0 flex items-center justify-center ${
                selected ? 'border-primary' : 'border-[#C0C0C0] bg-white'
            }`}
        >
            {selected && <span className="h-2 w-2 rounded-full bg-primary" />}
        </div>
    );
}
